/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AccountBadgeGroupSwitcherQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type AccountBadgeGroupSwitcherQuery = {
  __typename?: 'Query'
  groups: Array<{
    __typename?: 'BackofficeUserManagementGroup'
    name: string
    displayName: string
    assignedOrganizations: Array<string> | null
  }>
}

export type SwitchGroupsMutationVariables = Types.Exact<{
  input: Types.BackofficeUserManagementSwapGroupsInput
}>

export type SwitchGroupsMutation = {
  __typename?: 'Mutation'
  backofficeUserManagementSwapGroups: {
    __typename?: 'BackofficeUser'
    id: string
  }
}

export const AccountBadgeGroupSwitcherDocument = gql`
    query AccountBadgeGroupSwitcher {
  groups: backofficeUserManagementGroups {
    name
    displayName
    assignedOrganizations
  }
}
    `

/**
 * __useAccountBadgeGroupSwitcherQuery__
 *
 * To run a query within a React component, call `useAccountBadgeGroupSwitcherQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBadgeGroupSwitcherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBadgeGroupSwitcherQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountBadgeGroupSwitcherQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountBadgeGroupSwitcherQuery,
    AccountBadgeGroupSwitcherQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AccountBadgeGroupSwitcherQuery,
    AccountBadgeGroupSwitcherQueryVariables
  >(AccountBadgeGroupSwitcherDocument, options)
}
export function useAccountBadgeGroupSwitcherLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountBadgeGroupSwitcherQuery,
    AccountBadgeGroupSwitcherQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AccountBadgeGroupSwitcherQuery,
    AccountBadgeGroupSwitcherQueryVariables
  >(AccountBadgeGroupSwitcherDocument, options)
}
// @ts-ignore
export function useAccountBadgeGroupSwitcherSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AccountBadgeGroupSwitcherQuery,
    AccountBadgeGroupSwitcherQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AccountBadgeGroupSwitcherQuery,
  AccountBadgeGroupSwitcherQueryVariables
>
export function useAccountBadgeGroupSwitcherSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountBadgeGroupSwitcherQuery,
        AccountBadgeGroupSwitcherQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AccountBadgeGroupSwitcherQuery | undefined,
  AccountBadgeGroupSwitcherQueryVariables
>
export function useAccountBadgeGroupSwitcherSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AccountBadgeGroupSwitcherQuery,
        AccountBadgeGroupSwitcherQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AccountBadgeGroupSwitcherQuery,
    AccountBadgeGroupSwitcherQueryVariables
  >(AccountBadgeGroupSwitcherDocument, options)
}
export type AccountBadgeGroupSwitcherQueryHookResult = ReturnType<
  typeof useAccountBadgeGroupSwitcherQuery
>
export type AccountBadgeGroupSwitcherLazyQueryHookResult = ReturnType<
  typeof useAccountBadgeGroupSwitcherLazyQuery
>
export type AccountBadgeGroupSwitcherSuspenseQueryHookResult = ReturnType<
  typeof useAccountBadgeGroupSwitcherSuspenseQuery
>
export type AccountBadgeGroupSwitcherQueryResult = Apollo.QueryResult<
  AccountBadgeGroupSwitcherQuery,
  AccountBadgeGroupSwitcherQueryVariables
>
export const SwitchGroupsDocument = gql`
    mutation SwitchGroups($input: BackofficeUserManagementSwapGroupsInput!) {
  backofficeUserManagementSwapGroups(input: $input) {
    id
  }
}
    `
export type SwitchGroupsMutationFn = Apollo.MutationFunction<
  SwitchGroupsMutation,
  SwitchGroupsMutationVariables
>

/**
 * __useSwitchGroupsMutation__
 *
 * To run a mutation, you first call `useSwitchGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchGroupsMutation, { data, loading, error }] = useSwitchGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchGroupsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SwitchGroupsMutation,
    SwitchGroupsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SwitchGroupsMutation,
    SwitchGroupsMutationVariables
  >(SwitchGroupsDocument, options)
}
export type SwitchGroupsMutationHookResult = ReturnType<
  typeof useSwitchGroupsMutation
>
export type SwitchGroupsMutationResult =
  Apollo.MutationResult<SwitchGroupsMutation>
export type SwitchGroupsMutationOptions = Apollo.BaseMutationOptions<
  SwitchGroupsMutation,
  SwitchGroupsMutationVariables
>
